module.exports = __webpack_public_path__ + "static/media/serviceCenter_cont_left_img.c3e3f454.png";